import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LicenseManager } from 'ag-grid-enterprise';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/* eslint-disable */
// prettier-ignore
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-053228}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Luminous}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Luminous}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Luminous}_need_to_be_licensed___{Luminous}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_January_2025}____[v3]_[01]_MTczNjU1MzYwMDAwMA==3ee28f67f0288d89b894f43f6897455c');
/* eslint-enable */

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err)); // eslint-disable-line no-console
